import type { DateValue } from "react-aria-components";

import { Timezone } from "@nlc/shared-types";
import { useMemo } from "react";

import type { DueDateDisplay } from "@/utils/dueDateDisplay";

import { getDueDateDisplay } from "@/utils/dueDateDisplay";

export function useDateDisplay(
  date: DateValue | null | undefined,
): DueDateDisplay | null {
  return useMemo(() => {
    if (!date) return null;

    return getDueDateDisplay(date.toDate(Timezone.EST).toISOString());
  }, [date]);
}
